module.exports = __webpack_public_path__ + "img/d4.e4d22c91.png";